import { render, staticRenderFns } from "./MPagination.vue?vue&type=template&id=3beb3f08&scoped=true"
import script from "./MPagination.vue?vue&type=script&lang=js"
export * from "./MPagination.vue?vue&type=script&lang=js"
import style0 from "./MPagination.vue?vue&type=style&index=0&id=3beb3f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb3f08",
  null
  
)

export default component.exports